<template>
  <SaveModal
      color="warning"
      icon="mdi-pencil"
      :maxWidth="maxWidth"
      button="Upraviť"
      :itemKey="itemKey"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :saveData="updateData"
      @onSave="(response) => $emit('onUpdate', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          Item,
          errors,
          ItemForm
        }"
    >
      <slot
          name="default"
          :Item="Item"
          :errors="errors"
          :ItemForm="ItemForm"
      />
    </template>
  </SaveModal>
</template>

<script>
  import SaveModal from '@/components/_Part/_Modal/Save'

  export default {
    name: 'Update',
    props: [
      'maxWidth',
      'itemKey',
      'fetchData',
      'setTitle',
      'setItemForm',
      'updateData'
    ],
    emits: [
      'onUpdate'
    ],
    components: {
      SaveModal
    }
  }
</script>
